import React from 'react';
import './css/services.css';

const Services = () => {
  const services = [
    {
      id: 1,
      title: 'Web Development',
      description:
        'I offer comprehensive web development services tailored to meet the unique needs of each client. From building responsive, user-friendly websites to creating custom web applications, I specialize in delivering high-quality solutions that drive results. Furthermore, due to my expertise in a range of programming languages and frameworks, I can handle every aspect of web development, including front-end design, back-end development, and database integration.',
      icon: 'fas fa-globe',
    },
    // {
    //   id: 2,
    //   title: 'Machine Learning Expert',
    //   description:
    //     'As a machine learning expert, I develop custom models and algorithms to solve complex business problems. In addittion to this I assist with data analysis, deployment, and maintenance of models, and offer consultation services to identify opportunities for integrating machine learning into operations. From exploring the potential of machine learning to optimizing existing solutions, I provide expertise and guidance to help clients achieve their goals.',
    //   icon: 'fas fa-mobile-alt',
    // },
    {
      id: 3,
      title: 'Data Scientist',
      description:
        'As a data scientist, I offer a wide range of services to help businesses make data-driven decisions. My expertise includes data analysis, machine learning, statistical modeling and data visualization. Moreover I am well aquinted with data collection, cleaning and processing, as well as developing predictive models and algorithms to drive business insights. I can provide the expertise and guidance necessary to succeed in a data-driven world.',
      icon: 'fas fa-palette',
    },
    {
      id: 4,
      title: 'Technical support',
      description:
        ' I offer technical support and troubleshooting services to clients who encounter issues with their software applications. I assist with diagnosing and resolving bugs and errors as well as provide ongoing maintenance and updates to ensure that software applications continue to meet the changing needs of clients and end-users.  I  am equipped with the skills and expertise to quickly and effectively resolve any problems to keep your software running smoothly.',
      icon: 'fas fa-chart-line',
    },
  ];

  return (
    <section id='services'>
    <div className="services-container">
      <h2>My Services</h2>
      <div className="services-grid">
        {services.map((service) => (
          <div key={service.id} className="service-card">
            <div className="service-icon">
              <i className={service.icon}></i>
            </div>
            <div className="service-content">
              <h3>{service.title}</h3>
              <p>{service.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
    </section>
  );
};

export default Services;


